/* eslint-disable max-len */
// ref: https://github.com/ant-design/ant-design/blob/d0cc4087ddd91f069dea88572f9ba24e984e3b18/components/radio/group.tsx
import type { RadioChangeEvent, RadioGroupProps } from 'antd/lib/radio';
import { useMemo, useState } from 'react';
import { RadioGroupContextProvider } from './Context';
import Radio from './Radio';

const RadioGroup = (props: RadioGroupProps) => {
    const { defaultValue, options, disabled, children, name, onChange } = props;

    const [value, setValue] = useState(defaultValue);

    const onRadioChange = (ev: RadioChangeEvent) => {
        const lastValue = value;
        const currentValue = ev.target.value;

        if (!('value' in props)) {
            setValue(currentValue);
        }

        if (onChange && currentValue !== lastValue) {
            onChange(ev);
        }
    };

    const innerChildren = useMemo(() => {
        if (options && options.length > 0) {
            return options.map(option => {
                if (typeof option === 'string' || typeof option === 'number') {
                    return (
                        <Radio key={option.toString()} checked={value === option} disabled={disabled} value={option}>
                            {option}
                        </Radio>
                    );
                }

                return (
                    <Radio
                        key={`radio-group-value-options-${option.value}`}
                        checked={value === option.value}
                        disabled={option.disabled || disabled}
                        value={option.value}
                    >
                        {option.label}
                    </Radio>
                );
            });
        }

        return children;
    }, [children, disabled, options, value]);

    return (
        <RadioGroupContextProvider
            value={{
                onChange: onRadioChange,
                value,
                disabled,
                name,
            }}
        >
            {innerChildren}
        </RadioGroupContextProvider>
    );
};

export default RadioGroup;
